export default function buildPostListingTagImage({
    apiEndpoint,
    apiTools
}) {
    return async function postListingTagImage(args) {
        const url = apiTools.resolveUrl({
            ...args,
            apiEndpoint: `${ apiEndpoint }/img` 
        })
       
        const res = await fetch(url, {
            method: 'POST',
            credentials: 'include',
            body: args.body
        });
        return await res.json();
    }
}